import React, { useEffect, useState } from 'react';
import SketchPicker, {
  PresetColor,
  SketchPickerProps
} from 'react-color/lib/components/sketch/Sketch';
import useThemes from '../hooks/useThemes';

/** Default color presets from the original SketchPicker dialog. */
const DEFAULT_PRESET_COLORS: PresetColor[] = [
  { color: '#D0021B', title: '#D0021B' },
  { color: '#F5A623', title: '#F5A623' },
  { color: '#F8E71C', title: '#F8E71C' },
  { color: '#8B572A', title: '#8B572A' },
  { color: '#7ED321', title: '#7ED321' },
  { color: '#417505', title: '#417505' },
  { color: '#BD10E0', title: '#BD10E0' },
  { color: '#9013FE', title: '#9013FE' },
  { color: '#4A90E2', title: '#4A90E2' },
  { color: '#50E3C2', title: '#50E3C2' },
  { color: '#B8E986', title: '#B8E986' },
  { color: '#000000', title: '#000000' },
  { color: '#4A4A4A', title: '#4A4A4A' },
  { color: '#9B9B9B', title: '#9B9B9B' },
  { color: '#FFFFFF', title: '#FFFFFF' }
];

/**
 * Render a SketchPicker with theme colors in the palette.
 * @param props Props passed to the inner SketchPicker.
 */
const SketchPickerTheme = (props: SketchPickerProps) => {
  const { muiTheme } = useThemes();
  const [presetColors, setPresetColors] = useState<PresetColor[]>();
  useEffect(() => {
    const themePresetColors: PresetColor[] = [
      { color: muiTheme.palette.primary.main, title: 'Theme Primary' },
      { color: muiTheme.palette.secondary.main, title: 'Theme Secondary' },
      { color: muiTheme.palette.error.main, title: 'Theme Error' },
      { color: muiTheme.palette.warning.main, title: 'Theme Warning' },
      { color: muiTheme.palette.info.main, title: 'Theme Info' },
      { color: muiTheme.palette.success.main, title: 'Theme Success' }
    ];
    setPresetColors(
      themePresetColors.concat(props.presetColors || DEFAULT_PRESET_COLORS)
    );
  }, [muiTheme, props.presetColors]);
  return (
    <SketchPicker
      {...props}
      color={props.color || undefined}
      presetColors={presetColors}
    />
  );
};

export default SketchPickerTheme;
